export class OrganizationApiService {
  constructor(http) {
    this.endpoint = '/organization/';
    this.http = http;
  }

  async get() {
    const { data } = await this.http.get(this.endpoint);
    return data;
  }

  async getBySlug(slug) {
    const { data } = await this.http.get(this.endpoint + `by_slug/${slug}`);
    return data;
  }

  async getByUuid(uuid) {
    const { data } = await this.http.get('/admin' + this.endpoint + uuid);
    return data;
  }

  async update(data) {
    await this.http.put(this.endpoint, data);
    return { status: 200 };
  }

  
  async websiteGet(anyparams) {
    let params = {};
    if (typeof anyparams !== 'undefined') {
      for (let key in anyparams) {
        params[key] = anyparams[key];
      }
    }
    const response = await this.http.get(this.endpoint + 'by_website/', params);
    return response.data;
  }

}
